export interface IAuthState {
    authenticated: boolean,
    accessToken: string | null
}

export const defaultAuthState: IAuthState = {
    authenticated: false,
    accessToken: null
}